import { IRequesterInfo } from "../../../../base/models"
import { ClientProxy } from "../../../../base/proxy/clientProxy"
import { CatalogItem } from "../models/models"

export class GetAdminMenuCatalogApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: `admin/admin-menu/catalog`,
      requesterInfo,
    })
  }

  public async GetAdminMenuCatalogApi(): Promise<CatalogItem[]> {
    return await this.getAsync<CatalogItem[]>()
  }
}
